export const resetPassword = {
    resetPassword: 'Reset Password',
    email: 'Email',
   sendingEmail: "We will be sending you an email to reset your password"
}